import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { mapData } from '../datamapper';
import { useAuth } from "./authcontext";
import {Link} from 'react-router-dom';
import { ShopContext } from './shopinfo';
import CartOverlay from './overlay_cart';
import '../warenkorb.css'

import { useCart } from './context4cart';

const Merkliste = () => {

        const { sqlID, callerID, sessionID} = useParams();
        const [confirmDeleteId, setConfirmDeleteId] = useState(null);
        const { setCartItemCount } = useCart();
        const { wishlist, fetchWishlist, updateWishlistItem, deleteWishlistItem } = useCart();

        const { pgid} = useContext(ShopContext);

        const {user} = useAuth();

        const [showCartOverlay, setShowCartOverlay] = useState(false);

        //NexusSelect
        const [covers, setCovers] = useState({});
        const [productinfo, setProductinfo] = useState({});
        const [meldetexte, setMeldetexte] = useState({});

        //OLA
        const [availability, setAvailability] = useState({});
        const [loading, setLoading] = useState(false);
        const [lastChecked, setLastChecked] = useState(null);

        //Warenkorb Edit
        const [editing, setEditing] = useState({});
               //Struktur:  { [wk_id]: { field: 'menge' | 'bestellzeichen' | null } }
        const [values, setValues] = useState({});
               //Struktur: { [wk_id]: { menge: number, bestellzeichen: string } }
        

        const [saving, setSaving] = useState({});


        const toggleEdit = (m_id, field, currentValue) => {
                setEditing(prev => ({
                  ...prev,
                  [m_id]: { field }
                }));
                setValues(prev => ({
                  ...prev,
                  [m_id]: { 
                    ...prev[m_id], 
                    [field]: currentValue 
                  }
                }));
          };       


          const handleChange = (m_id, field, newValue) => {
            setValues(prev => ({
              ...prev,
              [m_id]: {
                ...prev[m_id],
                [field]: newValue
              }
            }));
          };
          


        const lieferbarAnzeige = (meldenummer) => {
            if (meldenummer === '000') {
                return 'lieferbar';
            }
        }


        const saveChange = async (mz, field) => {
          if (field !== "bestellzeichen") return;
      
          const session_id = user?.session_id;
          const pg_id = user?.pgid;
          const caller = user?.aml;
      
          const newBZ = values[mz.m_id]?.bestellzeichen ?? "";
      
          const formData = new URLSearchParams();
          formData.append("session_id", session_id);
          formData.append("pg_id", pg_id);
          formData.append("caller", caller);
          formData.append("isbn", mz.isbn);
          formData.append("bestellzeichen", newBZ);
          formData.append("value", "update");   
          formData.append("m_id", mz.m_id);     
      
          try {
              const response = await fetch("/savemerkzettel", {
                  method: "POST",
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: formData.toString(),
              });
      
              const result = await response.json();
              console.log("Merkzettel update:", result);
              fetchWishlist();
              toggleEdit(mz.m_id, null);
      
          } catch (err) {
              console.error("Error updating bestellzeichen:", err);
              alert("Fehler beim Speichern.");
          }
      };

        useEffect(() => {
            if (wishlist.length > 0) {
              wishlist.forEach(mz => {
                fetchProductCover(mz.isbn);
                fetchProductDetailsFromNexus(mz.isbn);
              });
            }
          }, [wishlist]);

          useEffect(() => {
            wishlist.forEach((mz) => {
              if (!meldetexte[mz.isbn]) {
                fetchProductMeldetext(mz.isbn);
              }
            });
          }, [wishlist]);
      
          const fetchProductCover = async (isbn) => {
            try {
              console.log('Fetching cover for EAN:', isbn);
              const response = await fetch(`/search?ean=${isbn}`);
              if (!response.ok) throw new Error('Fetch failed');
        
              const data = await response.json();
                const mappedDataArray = mapData(data);

                
                const product = mappedDataArray[0]; 

                const firstCover = product?.cover?.[0];
              if (firstCover) {
                setCovers(prev => ({
                  ...prev,
                  [isbn]: firstCover,
                }));
              }
            } catch (error) {
              console.error(`Error fetching product for EAN ${isbn}:`, error);
            }
          };

          const fetchProductDetailsFromNexus = async (isbn) => {
            try {
              console.log('Fetching details for EAN:', isbn);
              const response = await fetch(`/search?ean=${isbn}`);
              if (!response.ok) throw new Error('Fetch failed');
          
              const data = await response.json();
              const mappedDataArray = mapData(data);
              const product = mappedDataArray[0]; 
          
              if (product) {
                setProductinfo(prev => ({
                  ...prev,
                  [isbn]: product,  
                }));
              }
          
            } catch (error) {
              console.error(`Error fetching product details for EAN ${isbn}:`, error);
            }
          };


          const fetchProductMeldetext = async (isbn) => {
            try {
              console.log("Fetching meldetext for EAN:", isbn);
              const response = await fetch(`/search?ean=${isbn}`);
              if (!response.ok) throw new Error("Fetch failed");
          
              const data = await response.json();
              const mappedDataArray = mapData(data);
              const product = mappedDataArray[0];
          
              if (product?.meldetext) {
                setMeldetexte((prev) => ({
                  ...prev,
                  [isbn]: product.meldetext,
                }));
              }
            } catch (error) {
              console.error(`Error fetching meldetext for EAN ${isbn}:`, error);
            }
          };

     

        const preisAnzeige = (preis) => {
            return preis.toFixed(2).replace('.',',');
        }  
 
       

        // ⬇️ useEffect just calls fetchWishlist once
        useEffect(() => {
            fetchWishlist();
        }, [sqlID, callerID, sessionID]);




    return (
        
            <div className="mainContentWrapper">

                <div className="contentContainer">
                    

                    
                            <br/>
                            <h4>Merkliste</h4> 
                        
                        
                            <> 

                         

                                    <hr className='hrUmb'/>
                                    <div className="wkFlex">
                                        

                                        {wishlist.map( mz => ( 
                                            <>
                                            
                                                <div class="wkContent wkGridResultsRow" key={mz.mz_id}>
                                                        
                                                        
                                                    <div className='wkColumnOne'>

                                                            <div className='wkCoverTitleBNRmitBZ'>
                                                                
                                                                <div className='wkCoverTitle'>
                                                                    

                                                               

                                                                    <div className="wkCover">
                                                                          <Link to={`/productdetails/${mz.isbn}`}>
                                                                              
                                                                          {covers[mz.isbn] && (
                                                                                <img
                                                                                    src={covers[mz.isbn]}
                                                                                    alt="Produktcover"
                                                                                    style={{ Width: '60px', maxWidth: '60px', height: 'auto', maxHeight: '100px', marginTop: '5px', marginBottom: '5px', }}
                                                                                />
                                                                                )}       


                                                                          </Link>    
                                                                  </div>     
                                                                    
                                                                    
                                                                    <div class="wkBestellnummer"> 
                                                                    <Link to={`/productdetails/${mz.isbn}`}>
                                                                        <i>{mz.isbn} </i>
                                                                        <br />
                                                                        {productinfo[mz.isbn]?.titel || 'Lade Titel...'}
                                                                        <br />
                                                                        {productinfo[mz.isbn]?.autor || ''}
                                                                      
                                                                        {productinfo[mz.isbn]?.herausgeber || ''}
                                                                        <br />
                                                                        {productinfo[mz.isbn]?.verlag || 'Lade Verlag...'}
                                                                        
                                                                      </Link> 
                                                                        
                                                                                                                                        
                                                                    </div>
                                                                </div>    
                                                                <div className="wkBestellzeichen">
                                                                <div className='bzinput'>
                                                                  {editing[mz.m_id]?.field === "bestellzeichen" ? (
                                                                    <>
                                                                      <input
                                                                        type="text"
                                                                        value={values[mz.m_id]?.bestellzeichen ?? ""}
                                                                        onChange={e =>
                                                                          handleChange(mz.m_id, "bestellzeichen", e.target.value)
                                                                        }
                                                                      />
                                                                      <button className='umbButtonIconAgree' onClick={() => saveChange(mz, "bestellzeichen")}>
                                                                        <span className="umbButtonIconAgreeHover"></span>
                                                                      </button>
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {mz.bestellzeichen} (BZ){" "}
                                                                     

                                                                      <button className="umbButtonIconEdit"
                                                                        onClick={() =>
                                                                          toggleEdit(mz.m_id, "bestellzeichen", mz.bestellzeichen)
                                                                        }
                                                                      > 
                                                                          <span className="umbButtonIconEditHover"></span>
                                                                       </button>
                                                                    </>
                                                                  )}
                                                                  </div>
                                                                 {/*  {saving[wk.wk_id] && <span style={{ marginLeft: 8, color: "orange" }}>⏳ Saving…</span>}*/} 
                                                                </div>


                                                            </div>                
                                                            
                                                    </div>    
                                                        
                                                    <div className='wkColumnTwo'>  
                                                            <div class="wkPreisAnzeige"> 
                                                                <div className='wkSingleElement'>
                                                                    <b> {productinfo[mz.isbn]?.preis != null
                                                                        ? `${Number(productinfo[mz.isbn].preis)
                                                                            .toFixed(2)
                                                                            .replace('.', ',')} €`
                                                                        : ' '}
                                                                       </b>                                                                     
                                                                </div>
                                                        
                                                          
                                                            <div className='wkSingleElement'>   
                                                                <div className='styledDiv'>
                                                                    

                                                                    {availability[mz.isbn]?.ok === 1 && (
                                                                        <div className="lieferbar">Sofort lieferbar</div>
                                                                    )}
                                                                    {availability[mz.isbn]?.ok === 0 && (
                                                                        <div className="nichtLieferbar">
                                                                        
                                                                            {availability[mz.isbn]?.liefermenge !== null && (
                                                                                <div>
                                                                                    Gewünschte Menge nicht lieferbar, verfügbar: {availability[mz.isbn].liefermenge} Stück
                                                                                </div>
                                                                            )}    
                                                                        
                                                                        </div>
                                                                    )}
                                                                
                                                                </div>

                                                            
                                                            </div>  
                                                            <div className="wkSingleElement">
                                                                    {meldetexte[mz.isbn] || "Keine Meldung"}
                                                                </div>
                                                        
                                                                </div>
                                                            
                                                            
                                                    </div>




                                                        <div class="wkButtons">
                                                            
                                                            <div className='wkSingleElement'>        
                                                                    <button
                                                                        className="umbButtonIconCart" 
                                                                        onClick={() => {setShowCartOverlay(mz.isbn)}}
                                                                    > 
                                                                        <span className="iconCartHover"></span>
                                                                    </button> 

                                                                    {showCartOverlay === mz.isbn && (
                                                                      <CartOverlay
                                                                          isbn={mz.isbn}
                                                                          titel={mz.titel}
                                                                          preis={productinfo[mz.isbn]?.preis}
                                                                    
                                                                          autor={mz.autor}
                                                                          m_id={mz.m_id} 
                                                                          onClose={() => setShowCartOverlay(null)}
                                                                      />
                                                                  )}
                                                            </div>
                                                          <br />
                                                            <div className='wkSingleElement'>        
                                                                    <button className="umbButtonIconDelete" onClick={() => setConfirmDeleteId(mz.m_id)}> 
                                                                        <span className="iconDeletetHover"></span>
                                                                    </button>  
                                                            </div>
                                                                
                                                                

                                                        </div>
                                                         
                                                </div>
                                              
                                            </>
                                           

                                        ))}    

                                            {confirmDeleteId && (
                                                <div className="overlayBackdrop">
                                                <div className="overlayBox">
                                                    <p>Möchten Sie diesen Artikel wirklich löschen?</p>
                                                    <div className="overlayButtons">
                                                    <button className='umbButton' onClick={() => {
                                                        deleteWishlistItem(confirmDeleteId);
                                                        setConfirmDeleteId(null); // close overlay
                                                    }}>
                                                        Ja, löschen
                                                    </button>
                                                    <button className='umbButton' onClick={() => setConfirmDeleteId(null)}>
                                                        Abbrechen
                                                    </button>
                                                    </div>
                                                </div>
                                                </div>
                                            )}

                                    </div>  

                                    <div>

                                        
                                    </div>    
                            </>
                        
                                

                    </div>
            </div>
                




    )
}
 
export default Merkliste;